import { useCallback } from 'react'

import { BulkUpdateTaskStatusPlanningPlanningDocument } from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'
import i18n from 'modules/core/lib/i18n'

import { TaskActionsHook, TaskDefinition } from 'modules/inbox_tasks/lib/abstraction'

const usePlanningPlannerTaskActions: TaskActionsHook<'PlanningPlanner'> = ({ taskable }) => {
  const [bulkUpdateTaskStatus] = useMutation(BulkUpdateTaskStatusPlanningPlanningDocument, {
    extractorFn: (data) => data.planningMutations.bulkUpdateTaskStatusPlanningPlanning,
  })

  const onClickPrimaryAction = useCallback(async () => {
    const planningId = taskable?.planningPlanningId

    if (!planningId) {
      return false
    }

    await bulkUpdateTaskStatus({
      variables: {
        updates: [
          {
            id: planningId,
            taskStatus: 'done',
          },
        ],
      },
      refetchQueries: ['NewInboxTasks'],
    })

    return true
  }, [bulkUpdateTaskStatus, taskable?.planningPlanningId])

  return {
    onClickPrimaryAction,
  }
}

export const PlanningPlannerTaskDefinition: TaskDefinition<'PlanningPlanner'> = {
  taskableTypename: 'PlanningPlanner',
  getTitle: () => {
    return i18n.t('planning.tasks.planning_created.name')
  },
  getUrl: ({ info, navigation }) => {
    if (info.planningPeriodId) {
      return navigation.finance.financialWorkspace.headcountPlanning.periodDetail.fullPath({
        periodId: String(info.planningPeriodId),
      })
    }

    return navigation.finance.financialWorkspace.headcountPlanning.fullPath()
  },
  useActions: usePlanningPlannerTaskActions,
}
